import request from '@/utils/request'

export function getAllPayeh() {
  return request({
    url: 'karnameh/payeh',
    method: 'post'
  })
}




